import React, { useEffect, useState } from "react";
import classNames from "classnames";
import "./index.scss";

import { getAddressSuggestions } from "../../../services/order";
import { getCurrentContryCode } from "../../../services/restaurant";

import { DebounceInput } from "react-debounce-input";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";
import SectionItemMapAddress from "../SectionItemMapAddress";

const SectionItemCity = ({ item, value, column, onPropChange }) => {
    const [currentValue, setCurrentValue] = useState(value || item.name || "");
    const [items, setItems] = useState([]);

    const handleOnChange = e => {
        if(!column.isReadonly) {
            setCurrentValue(e.target.value);
            getAddressSuggestions("", e.target.value, getCurrentContryCode(), true).then(data=> {
                setItems(data ? data.map(m=> m.address) : []);
            });
        }
    }

    const handleOnSelect = val => {
        if(!column.isReadonly) {
            onPropChange({ [column.accessor]: val.city });
            setCurrentValue(val.city);
            setItems([]);
        }        
    }

    useEffect(()=> {
        setCurrentValue(value);
    }, [value]);

    const handleOnMapChange = ({address}) => {
        onPropChange({ location: address.location, [column.accessor]: address.address.city });
        setCurrentValue(address.address.city);
    }

    return (
        <div className={classNames("sectionItemCity")}>
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
            <div className={classNames("citySearch")}>
                <DebounceInput
                    value={currentValue || ''}
                    className={classNames("searchInput")}
                    debounceTimeout={column.debounce || 1000}
                    onChange={handleOnChange}            
                />
                {items && items.length > 0 && (
                    <div className={classNames("citySearchItems")}>
                        {items.map(item=> (
                            <div key={`citySearchItem-${item.city}`} className={classNames("citySearchItem")}
                                onClick={()=> handleOnSelect(item)}
                            >
                                {item.city}
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <SectionItemMapAddress
                item={item}
                value={{location: item.location}}
                column={column}
                onPropChange={handleOnMapChange}
            />
        </div>
    );
}

export default SectionItemCity;